import React from 'react'
import { Box } from '@mui/material'
import type { StepIndex } from './schema'

const STEP_COUNT = 3

type Props = { current: StepIndex }

export const Stepper: React.FC<Props> = ({ current }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', mb: '28px' }}>
    {Array.from({ length: STEP_COUNT }, (_, i) => {
      const active = i <= current
      return (
        <React.Fragment key={i}>
          <Box
            sx={{
              width: 30,
              height: 30,
              borderRadius: '50%',
              backgroundColor: active ? 'primary.main' : 'neutral.lightGray',
              color: active ? 'common.white' : 'neutral.mediumGray',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 800,
              fontSize: 13,
              transition: 'background-color 0.2s, color 0.2s',
            }}
          >
            {i + 1}
          </Box>
          {i < STEP_COUNT - 1 && (
            <Box
              sx={{
                width: 44,
                height: 2,
                backgroundColor:
                  i < current ? 'primary.main' : 'neutral.lightGray',
                transition: 'background-color 0.2s',
              }}
            />
          )}
        </React.Fragment>
      )
    })}
  </Box>
)
